import resetForm from 'cerebral-module-forms/factories/resetForm'

export default function resetAllForms() {
  function action(context) {
    let state = context.state
    let forms = state.get('client.registrating.current')
    Object.keys(forms).forEach(form => {
      resetForm(`client.registrating.current.${form}`)(context)
    })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/resetAllForms.js